export function loadScript(src: string, asynchronously: boolean, deferExecution: boolean, identify: string): HTMLElement | undefined {
  const elementScript = document.head.getElementsByTagName('script');
  const exist = Array.from(elementScript).some((element) => {
    return element.getAttribute('identify') === identify;
  });

  if (exist) return;

  const tag = document.createElement('script');
  tag.async = asynchronously;
  tag.src = src;
  tag.defer = deferExecution;
  tag.setAttribute('identify', identify);
  document.head.appendChild(tag);
  return tag;
}

export default loadScript;
